export const team19=[{
    year:"2019",
    "CoreTeam":[{
    "Name": "Anushka Enugu",
    "Position": "Committee Member",
     "ImgPath":"anushka.jpg"
  },
  {
    "Name": "Akula Jyothsna",
    "Position": "Committee Member",
     "ImgPath":"jyothsna.jpg"
  },
  {
    "Name": "Kavitha Kethavath",
    "Position": "Committee Member",
     "ImgPath":"kavitha.jpg"
  },
  {
    "Name": "Triveni Kotte",
    "Position": "Committee Member",
     "ImgPath":"triveni.jpg"
  },
  {
    "Name": "Aditya Palavajjhala",
    "Position": "Committee Member",
     "ImgPath":"adithys.jpg"
  },
  {
    "Name": "Glory Rapalli",
    "Position": "Committee Member",
     "ImgPath":"glory.jpg"
  },
  {
    "Name": "Gannoji Saikumar",
    "Position": "Committee Member",
     "ImgPath":"saikumar.jpg"
  },
  {
    "Name": "Konda Sanjana",
    "Position": "Committee Member",
     "ImgPath":"sanjana.jpg"
  },
  {
    "Name": "Anuhya Sankranti",
    "Position": "Committee Member",
    "ImgPath":"anuhya.jpg"
  },
  {
    "Name": "Aryan Reddy ",
    "Position": "Committee Member",
     "ImgPath":"aryan.jpg"
  },
  {
    "Name": "Nagandla Tharanya",
    "Position": "Committee Member",
     "ImgPath":"tharanya.jpg"
  },
  {
    "Name": "Shriya Vinjam",
    "Position": "Committee Member",
     "ImgPath":"vinjam.jpg"
  }],
    "Volunteers":[
  { "Name": "Sai Preetham", "Team": "Technical Team" },
  { "Name": "B. Prashanth", "Team": "Technical Team" },
  { "Name": "Vardhan", "Team": "Technical Team" },
  { "Name": "Madhurendra Tripathy", "Team": "Technical Team" },
  { "Name": "P. Akhila", "Team": "Technical Team" },
  { "Name": "Shilhora Akshay", "Team": "Technical Team" },

  { "Name": "Vaishnavi", "Team": "Designing Team" },
  { "Name": "A. Swetha", "Team": "Designing Team" },
  { "Name": "N. Manaswini", "Team": "Designing Team" },
  { "Name": "B. Nikhil Kumar", "Team": "Designing Team" },

  { "Name": "Sanjana", "Team": "Social Media Team" },
  { "Name": "Akanshith", "Team": "Social Media Team" },
  { "Name": "K. Srujana", "Team": "Social Media Team" },
  { "Name": "N. Jahnavi", "Team": "Social Media Team" },

  { "Name": "G. Sharathchandra", "Team": "Events & Support" },
  { "Name": "P. Chandra Sekhar", "Team": "Events & Support" },
  { "Name": "M. Sucharitha", "Team": "Events & Support" },
  { "Name": "Eshwar", "Team": "Events & Support" },
  { "Name": "M. Tejaswini", "Team": "Events & Support" },
  { "Name": "P. Vaibhavi", "Team": "Events & Support" }
]

}]